/* eslint-disable no-nested-ternary */
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { EPermissions } from 'projects/common/src/app/enumerables/permissions';
import { ITableConfig } from 'projects/common/src/app/interfaces/table/table-config';
import { ITableDataParams } from 'projects/common/src/app/interfaces/table/table-data-params';
import { ITableExtraParams } from 'projects/common/src/app/interfaces/table/table-extra-params';
import { ITableHeaderParams } from 'projects/common/src/app/interfaces/table/table-header-params';
import { CacheService } from 'projects/common/src/app/services/cache.service';
import { TableConfigService } from 'projects/common/src/app/services/table/table-config.service';
import { Subscription } from 'rxjs';
import { IFilterData, IZoneDetail } from 'src/app/modules/administration/interfaces';
import { IZoneTreeList } from 'src/app/modules/administration/interfaces/zoneTreeList';
import { ZoneService } from 'src/app/modules/administration/services';
import { PermissionService } from 'src/app/modules/core/services/parameter/permission/permission.service';

@Component({
  selector: 'app-production-by-street-table',
  templateUrl: './production-by-street-table.component.html',
  styleUrls: ['./production-by-street-table.component.scss'],
})
export class ProductionByStreetTableComponent implements OnInit, OnDestroy {
  @Input()
  public collection: any;

  public collections: any;
  public tableConfig: ITableConfig;
  public tableData: any;
  public valueSearchShift: any;
  public sector = [];
  public street = [];
  public selectedSector: '';
  public selectedStreet: '';
  public valueFilter: string;
  public companyId: number;
  public rawZoneList: IZoneTreeList[] = [];
  public zoneList: IZoneDetail[] = [];
  public isCleared = false;
  parentChildVisibleNames: string[][] = [];

  public filterForm = this.fb.group({
    levelTwo: new FormControl(null),
    levelThree: new FormControl({ value: null, disabled: true }),
    search: new FormControl(''),
  });
  public subscriptions: Subscription[] = [];
  public readonly PERMISSION_OBJECT = 'LEY DE MINERAL';
  public canVisualize = false;

  constructor(
    private tableService: TableConfigService,
    private zoneService: ZoneService,
    private fb: FormBuilder,
    private cacheService: CacheService,
    private permissionService: PermissionService,
  ) {}

  ngOnInit(): void {
    this.collections = this.collection.tbProductionByStreet;
    const permissions = this.permissionService.getPermissionsByObj(this.PERMISSION_OBJECT);
    this.canVisualize = permissions.some(({ permission }) => permission.toLowerCase() === EPermissions.VISUALIZE.toLowerCase());
    this.initListeners();
    this.getZone();
    this.setTableConfig(this.collections);
  }

  /**
   * Starts the component listeners
   */
  public initListeners(): void {
    Object.keys(this.filterForm.controls).forEach((form) => {
      this.subscriptions.push(this.filterForm.get(form).valueChanges.subscribe(() => this.filterData(form)));
    });
  }

  /**
   * Filter the data based on filters
   */
  public filterData(form?: string): void {
    this.isCleared = false;
    const { controls } = this.filterForm;
    const levelTwo = controls.levelTwo.value;
    let levelThree = controls.levelThree.value;
    const search = controls.search.value;
    let currentData = [...this.collections];

    if (form === 'levelTwo') {
      this.filterForm.get('levelThree').reset(null, { emitEvent: false });
      levelThree = null;
      this.street = [];
    }

    currentData = this.filterDataByFilters(currentData, levelTwo, levelThree);

    if (levelTwo) {
      this.street = this.createListLevel('level3', this.setFilter(this.zoneList, levelTwo));
      this.filterForm.get('levelThree').enable({ emitEvent: false });
    }

    if (search) {
      this.valueFilter = search;
    } else {
      this.setTableConfig(currentData);
      this.valueFilter = '';
    }
    this.setTableConfig(currentData, this.valueFilter && this.valueFilter.length > 0 ? this.valueFilter : '');
    if (!this.sector.length) {
      this.filterForm.get('levelTwo').disable({ emitEvent: false });
    }
    if (!this.street.length) {
      this.filterForm.get('levelThree').disable({ emitEvent: false });
    }
  }

  /**
   * Reset and disable control in a filter form.
   */
  public resetAndDisableControlForm(controlName: string): void {
    this.filterForm.get(controlName).reset(null, { emitEvent: false });
    this.filterForm.get(controlName).disable({ emitEvent: false });
  }

  public getZone(): void {
    this.zoneService.getZonesTreeTable().then((value) => {
      this.rawZoneList = value;
      this.zoneList = this.rawZoneList.map(({ level1, level2, level3, level4, isActive, zoneId }) => {
        const zoneObj: any = {
          level1,
          level2,
          level3,
          level4,
          zoneId,
        };
        Object.assign(zoneObj, { status: isActive });
        return zoneObj;
      });
      this.sector = this.createListLevel('level2');
    });
  }

  getParentChildVisibleNames(menu: any): void {
    if (menu.childs && menu.childs.length > 0) {
      const parentChildNames: string[] = [menu.visibleName];
      menu.childs.forEach((child) => {
        parentChildNames.push(child.visibleName);
        this.getParentChildVisibleNames(child);
      });
      this.parentChildVisibleNames.push(parentChildNames);
    }
  }

  public createListLevel(levelName: string, data = this.zoneList): { id: number; name: string }[] {
    this.parentChildVisibleNames = [];
    const { visibleName } = this.cacheService.session('selectedMenu');
    const app = this.cacheService.session('app');
    this.getParentChildVisibleNames(app);

    const parentName = this.parentChildVisibleNames.find((x) => x.includes(visibleName))[0];

    return data.reduce((list, current, index) => {
      if (current.level1 === parentName) {
        if (list.findIndex((value) => value.name === current[levelName]) === -1 && current[levelName] !== '-') {
          const level = {
            id: index + 1,
            name: current[levelName],
          };
          list = [...list, level];
        }
      }
      return list;
    }, []);
  }

  /**
   * Filter data by filters selected.
   */
  public filterDataByFilters(currentData: any[], levelTwo?: IFilterData, levelThree?: IFilterData): any[] {
    let filteredData = currentData;
    if (levelTwo || levelThree) {
      filteredData = filteredData.filter((data) => {
        let condition = true;

        // if (levelTwo) {
        //   condition = condition && data.level2 === levelTwo.name;
        // }

        if (levelThree) {
          condition = condition && data.streetName === levelThree.name;
        }

        return condition;
      });
    }

    if (this.valueFilter) {
      filteredData = filteredData.map((row) => {
        const rowFinded = Object.values(row).find((col: string) => {
          return typeof col === 'string' ? col.toLowerCase().includes(this.valueFilter.toLowerCase()) : false;
        });
        return rowFinded ? row : null;
      });
      filteredData = filteredData.filter(Boolean);
    }

    return filteredData;
  }
  public setFilter(currentData: any[], levelTwo?: IFilterData, levelThree?: IFilterData): any[] {
    let filteredData = currentData;
    if (levelTwo || levelThree) {
      filteredData = filteredData.filter((data) => {
        let condition = true;

        if (levelTwo) {
          condition = condition && data.level2 === levelTwo.name;
        }

        if (levelThree) {
          condition = condition && data.level3 === levelThree.name;
        }

        return condition;
      });
    }

    return filteredData;
  }

  public setTableConfig(tableData: any[], noDataMsgParam?: string): void {
    const data = [];
    const { shiftId } = this.cacheService.session('shift');
    tableData.forEach((td) => {
      if (shiftId !== -1) {
        delete td.shiftName;
      }
      data.push({
        streetName: td.streetName,
        shiftName: td.shiftName,
        zoneName: td.zoneName,
        conditionName: td.conditionName,
        // humidityObs: td.humidityObs,
        // matrixColor: td.matrixColor,
        grade: td.grade === null ? '-' : `${td.grade.toFixed(2)}%`,
        done: td.done,
        scheduledDone: td.scheduledDone,
        scheduled: td.scheduled,
        notScheduledDoneLoops: td.notScheduledDoneLoops,
        remainder: td.remainder,
        compliance: `${td.compliance}%`,
      });
    });

    const excludeColumns = !this.canVisualize
      ? ['streetId', 'spotId', 'zoneId', 'matrixColor', 'humidityObs', 'grade']
      : ['streetId', 'spotId', 'zoneId', 'matrixColor', 'humidityObs'];

    const headerParams: ITableHeaderParams = {
      data,
      excludeColumns,
      customLargeColumns: [],
      replaceColumnName: [
        { prevName: 'conditionName', newName: 'condition-situation' },
        { prevName: 'humidityObs', newName: 'humidity' },
      ],
    };
    const datasetParams: ITableDataParams = {
      tableData: data,
      excludeColumns,
      customLargeColumns: [],
      // colorConfig: [{ field: 'humidityObs', color: this.setColorConfig(tableData) }], comentado hasta validar dicho campo
    };

    const extraParams: ITableExtraParams = {
      noDataMsg: this.collections && this.collections.length === 0 ? 'm056' : noDataMsgParam ? '_m021' : 'm021',
      noDataMsgParam,
      minimalRows: tableData.length,
    };

    const header = this.tableService.setHeaderConfig(headerParams);
    const dataset = this.tableService.setDatasetConfig(datasetParams);

    this.tableConfig = { header, dataset, extraParams };
  }

  setColorConfig(tableData: any): string {
    return tableData.forEach((td) => {
      return td.matrixColor;
    });
  }

  public reset() {
    this.isCleared = true;
    this.filterForm.reset();
    this.setTableConfig(this.collections);
  }
  /**
   * On destroy component.
   */
  public ngOnDestroy(): void {
    this.subscriptions.forEach((subs) => subs.unsubscribe());
  }
}
